var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.78 27.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#868787;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.89,19.75a8,8,0,0,0-8,8H8a5.89,5.89,0,0,1,1-3.31L11.57,27a2.45,2.45,0,0,0-.12.78h4.88A2.45,2.45,0,0,0,16.2,27l2.53-2.53a5.89,5.89,0,0,1,1,3.31h2.17A8,8,0,0,0,13.89,19.75Zm-.78,5.71-2.52-2.52a5.85,5.85,0,0,1,6.6,0l-2.52,2.52a2.54,2.54,0,0,0-.78-.12,2.5,2.5,0,0,0-.78.12ZM23.71,18a13.6,13.6,0,0,0-5.28-3.31,8,8,0,1,0-9.08,0A13.6,13.6,0,0,0,4.07,18,13.76,13.76,0,0,0,0,27.78H2.17a11.72,11.72,0,1,1,23.44,0h2.17A13.81,13.81,0,0,0,23.71,18ZM8,8a5.86,5.86,0,1,1,5.86,5.86A5.86,5.86,0,0,1,8,8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverId);
export default __webpack_public_path__ + "static/media/driver-id.d00a60ac6468ee670be4df72fd59af9f.svg";
export { ForwardRef as ReactComponent };